import type { Address } from "viem";
import { useConnection } from "wagmi";
import { robinhood } from "./config";
import { DEMO_ADDRESS, useDemoWallet, useMode } from "./demo";

export type Wallet = { address?: Address; isConnected: boolean; chainId?: number; demo: boolean };

/** The connected account: the real wallet, or the demo wallet in preview mode. */
export function useWallet(): Wallet {
  const conn = useConnection();
  const mode = useMode();
  const demoOn = useDemoWallet();
  if (mode === "demo") return { address: demoOn ? DEMO_ADDRESS : undefined, isConnected: demoOn, chainId: robinhood.id, demo: true };
  return { address: conn.address, isConnected: conn.isConnected, chainId: conn.chainId, demo: false };
}
